import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "preview",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "preview-set" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
